import { render, staticRenderFns } from "./tab-item.vue?vue&type=template&id=32785319&scoped=true&"
import script from "./tab-item.vue?vue&type=script&lang=js&"
export * from "./tab-item.vue?vue&type=script&lang=js&"
import style0 from "./tab-item.vue?vue&type=style&index=0&id=32785319&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32785319",
  null
  
)

export default component.exports